// extracted by mini-css-extract-plugin
module.exports = {"list":"OverheadSpendingsList_list__3IE97"};